import { PageLimitFilter } from '@typings';
import { Row, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useFinancialCustomerSubscriptions } from '../../hooks/useCustomerFinancial';
import { SubscriptionsTable } from './SubscriptionsTable';

const { Title } = Typography;

interface CustomerFinancialTabProps {
  customerDocument: string;
  customerEmail: string;
  customerId: string;
}

const TOTAL_SUBSCRIPTIONS_PER_PAGE = 20;

export const CustomerFinancialTab: React.FC<CustomerFinancialTabProps> = ({
  customerDocument,
  customerEmail,
  customerId,
}) => {
  const [pagination, setPagination] = useState<
    PageLimitFilter & { totalResults: number }
  >({
    limit: TOTAL_SUBSCRIPTIONS_PER_PAGE,
    page: 1,
    totalResults: 0,
  });
  const { data: subscriptions, isLoading } = useFinancialCustomerSubscriptions(
    customerId,
    {
      limit: pagination.limit,
      page: pagination.page,
    }
  );

  useEffect(() => {
    if (subscriptions?.total) {
      setPagination(prev => ({
        ...prev,
        totalResults: subscriptions.total,
      }));
    }
  }, [subscriptions?.total]);

  const handlePaginationChange = (page: number) => {
    setPagination(prev => ({
      ...prev,
      page,
    }));
  };

  return (
    <Space
      direction='vertical'
      size='large'
      style={{ display: 'flex', marginTop: 24 }}
    >
      <Title level={5} style={{ margin: 0 }}>
        Assinaturas e Pagamentos
      </Title>
      <Row
        style={{
          overflowX: 'auto',
          position: 'relative',
          width: '100%',
          paddingBottom: '20px',
        }}
      >
        <CustomTableWrapper>
          <SubscriptionsTable
            subscriptions={subscriptions?.data ?? []}
            isLoading={isLoading}
            pagination={pagination}
            onPaginationChange={handlePaginationChange}
            customerDocument={customerDocument}
            customerEmail={customerEmail}
          />
        </CustomTableWrapper>
      </Row>
    </Space>
  );
};

const CustomTableWrapper = styled.div`
  display: inline-block;

  border-top: 1px solid #303030;
  border-left: 1px solid #303030;
  border-right: 1px solid #303030;

  * > .ant-table-cell-fix-right {
    width: 73px !important;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -47px;
      width: 47px;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgba(20, 20, 20, 0) 12.96%,
        #141414 100%
      );
      border-right: 1px solid #303030 !important;

      z-index: 10;
    }
  }
`;
